

























import { Vue, Component } from "vue-property-decorator";
import { Field, CellGroup, DropdownItem } from "vant";

@Component({
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
  },
})
export default class extends Vue {
  back() {
    history.back();
  }
  next(){
    this.$router.push('/user/resetpwd/mobileValidate')
  }
}
